<template>
  <div>
    <!-- {{ JSON.stringify(dataSource) }} -->
    <dx-data-grid
      :show-borders="true"
      :ref="'batch-child-grid-' + templateData.key"
      :columns="masterDetailColumns"
      :data-source="dataSource"
      :two-way-binding-enabled="true"
      @editor-preparing="onEditorPreparing"
      @content-ready="onContentReady"
      @init-new-row="onInitNewRow"
      @row-removed="onRowRemoved"
      :column-chooser="{ enabled: false }"
      :pager="{ visible: false }"
    >
      <DxSearchPanel :visible="false" />
      <DxEditing
        :allow-updating="allowEdit"
        :allow-deleting="allowEdit"
        mode="cell"
      />
      <template #itemSelect="{ data }">
        <div class="custom-auto-complete">
          <span class="auto-complete-primary">{{ data.Description }}</span>
          <span class="auto-complete-secondary">{{ data.ItemCode }}</span>
        </div>
      </template>
      <template #fieldSelect="{ data }">
        <div class="custom-auto-complete">
          <DxTextBox
            :value="data && data.Description"
            :read-only="!allowEdit"
            class="gc-grid-description"
          />

          <span v-if="data" class="gc-grid-code">
            {{ data.ItemCode }}
          </span>
        </div>
      </template>

      <template #priceEditTemplate="{ data }">
        <div>
          <div>
            <DxNumberBox
              :value="data.value"
              @value-changed="defaultPriceChanged($event, data)"
              :format="getDecimalFormatByCode(2).Format"
              class="gc-grid-number-box-editor"
              :min="0"
              :max="999999999.99"
              :disabled="data.data.ProductCode == '' || !allowEdit"
            />
          </div>
        </div>
      </template>
      <template #product-menu-cell-template="{ data }">
        <DxDropDownButton
          :items="productLineContextMenu.getMenuItems(data)"
          keyExpr="menuText"
          displayExpr="menuText"
          :drop-down-options="{ width: 250 }"
          class="gc-dropdown-icon-button"
          :icon="productLineContextMenu.icon"
          styling-mode="text"
          :show-arrow-icon="false"
          :onItemClick="onProductLineContextMenuItemClick"
          :id="data.data.ProductCode"
          :disabled="baseView.mode == 'create'"
        />

        <!-- <DxDropDownButton
              :items="contractLineContextMenu.getMenuItems(data)"
              keyExpr="menuText"
              displayExpr="menuText"
              :drop-down-options="{ width: 250 }"
              class="gc-dropdown-icon-button"
              :id="data.data.Key"
              :icon="contractLineContextMenu.icon"
              styling-mode="text"
              :show-arrow-icon="false"
              :onItemClick="onContractLineContextMenuItemClick"
            /> -->
      </template>

      <template #qtyEditTemplate="{ data }">
        <div>
          <div>
            <DxNumberBox
              :value="data.value"
              :disabled="baseView.mode == 'review'"
              :format="getDecimalFormatByCode(7).Format"
              class="gc-grid-number-box-editor"
              :min="data.data.DrawnQuantity"
              :max="999999999.99"
              @value-changed="lineQtyChanged($event, data)"
            />
          </div>
        </div>
      </template>

      <template #action-cell-template="{ data }">
        <div>
          <!-- <DxButton icon="trash" @click="onClickDelete(data)" :disabled="data.data.DrawnQuantity > 0 && templateData.data.DrawnQuantity > 0"/>
          <DxButton icon="plus" @click="onAddClickHandler"/> -->
          <a
            class="dx-link dx-link-delete dx-icon-trash dx-link-icon"
            aria-label="Delete"
            @click="onClickDelete(data)"
            v-if="
              !(
                data.data.DrawnQuantity > 0 &&
                templateData.data.DrawnQuantity > 0
              )
            "
            title="Delete"
          >
          </a>
          <a
            class="dx-link dx-icon-plus dx-link-icon"
            @click="onAddClickHandler"
            title="Add Product Line"
          >
          </a>
        </div>
      </template>
    </dx-data-grid>
  </div>
</template>
<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import { DxNumberBox } from "devextreme-vue/number-box";
import BaseViewMixin from "../../../src/v1/_mixins/base.view";

import ApiService from "../../_services/api/api.service";

let baseLineBase = {
  ProductCode: "",
  DefaultPrice: 0,
  LineNo: null,
  RecordId: "00000000-0000-0000-0000-000000000000",
  DrawnQuantity: 0,
  Quantity: 0,
};

let addingNewBatchRow = false;

export default {
  components: { DxDataGrid, DxNumberBox },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    updateReviewList: {
      type: Function,
    },
    brokenGridValidations: {
      type: Array,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
    moreMenuCallBack: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [BaseViewMixin],
  computed: {
    noOfRecords() {
      return this.dataSource.length;
    },
    defaultPriceLabel() {
      return `Default Price (${this.parentModel.CurrencyCode})`;
    },

    masterDetailColumns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Product",
          dataField: "ProductCode",
          gcType: "String",
          gcSubType: "PrimaryChildRecord",
          editorType: "dxSelectBox",
          width: 500,
          editorOptions: {
            dataSource: ApiService.createDataSource(
              "api/SaleItemCompanyBranch",
              {
                filter: [
                  ["CompanyCode", "=", this.parentModel.CompanyCode],
                  ["BranchCode", "=", this.parentModel.BranchCode],
                  ["ItemType", "=", "S"],
                  ["SalesUM", "=", this.templateData.data.SalesUM],
                  ["Inactive", "=", "N"],
                  ["AvailableForSale", "=", "Y"],
                  ["Status", "=", "A"],
                ],
                select: [
                  "ItemCode",
                  "Description",
                  "Inactive",
                  "SalesUM",
                  "BranchCode",
                  "CompanyCode",
                ],
              }
            ),
            displayExpr: "Description",
            valueExpr: "ItemCode",
            searchExpr: ["ItemCode", "Description"],
            searchMode: "contains",
            showClearButton: true,
            itemTemplate: "itemSelect",
            fieldTemplate: "fieldSelect",
            searchEnabled: true,
            dropDownOptions: {
              minWidth: 500,
            },
            readOnly: this.allowEdit == false,
            // onSelectionChanged: (e) => {
            //   this.onSelectionChangedProduct(e);
            // },
          },
          showEditorAlways: true,
          allowEditing: true,
          cssClass: "gc-editor-cell",
        },
        {
          gcDynamicLabel: `Default Price (${this.parentModel.CurrencyCode})`,
          dataField: "DefaultPrice",
          gcType: "Decimal-6-2",
          cssClass: "gc-editor-cell",
          editCellTemplate: "priceEditTemplate",
          showEditorAlways: true,
        },
        {
          gcLabel: "Quantity",
          dataField: "Quantity",
          // gcType: "String",
          editorType: "dxNumberBox",
          // alignment: "right",
          // width: 150,
          gcType: "Decimal-6-2",
          cssClass: this.baseView.mode !== "review" ? "gc-editor-cell" : "",
          editCellTemplate: "qtyEditTemplate",
          showEditorAlways: true,
        },
        {
          gcLabel: "Drawn",
          dataField: "DrawnQuantity",
          // gcType: "String",
          gcType: "Decimal-6-2",
          //  width: 100,
          setWidth: 120,
          allowEditing: false,
        },
        {
          gcLabel: "",
          gcType: "String",
          type: "buttons",
          width: 100,
          visible: this.allowEdit,
          cellTemplate: "action-cell-template",
          // buttons: [
          //   "delete",
          //   {
          //     hint: "Add Product Line",
          //     icon: "plus",
          //     visible: true,
          //     onClick: this.onAddClickHandler.bind(this),
          //   },
          // ],
        },
        {
          gcLabel: "",
          gcType: "String",
          // gcSubType: "IconButton",
          cellTemplate: "product-menu-cell-template",
          cssClass: "more-menu",
          allowFixing: true,
          fixedPosition: "right",
          // fixed: true,
          width: 50,
          // showInColumnChooser: false,
        },
      ]);
    },
  },
  data() {
    return {
      dataSource: this.templateData.data.CustomerSalesContractItemConsumptions,

      productLineContextMenu: {
        icon: "overflow",
        getMenuItems: (data) => {
          let menuItems = [];

          // if (this.baseView.mode == "edit")
          // menuItems.push({ menuText: "Delete Line", data: data });
          if (
            this.templateData.data.LineNo &&
            this.templateData.data.LineNo > 0
          ) {
            menuItems.push({ menuText: "View History", data: data });
            if (
              this.baseView.mode == "review" &&
              this.templateData.data.CustomerSalesContractItemConsumptions
                .length > 0
            ) {
              if (this.parentModel.Type != "Allocation") {
                menuItems.unshift({ menuText: "Generate Order", data: data });
              }
              menuItems.unshift({ menuText: "Drawdown", data: data });
            }
          }
          return menuItems;
        },
      },
    };
  },
  created() {
    if (this.allowEdit && this.dataSource.length == 0) this.onAddClickHandler();
  },
  methods: {
    onClickDelete(e) {
      var grid = e.component;
      grid.deleteRow(e.rowIndex);
    },
    lineQtyChanged(e, data) {
      if (!e.event) return;
      data.data.Quantity = e.value;

      var lineQty = 0;

      this.dataSource.forEach((element) => {
        lineQty = lineQty + element.Quantity;
      });

      if (lineQty > this.templateData.data.Quantity)
        data.data.Quantity =
          data.data.Quantity - (lineQty - this.templateData.data.Quantity);

      e.component.beginUpdate();
      e.component.option("value", data.data.Quantity);
      e.component.endUpdate();
    },
    // onSelectionChangedProduct(e) {
    //   if (e.selectedItem) {
    //     var index = this.dataSource.findIndex(
    //       (x) => x.ProductCode == e.selectedItem.ItemCode
    //     );
    //     if (index > -1)
    //       this.dataSource[index]["ProductDescription"] =
    //         e.selectedItem.Description;
    //   }
    // },
    // eslint-disable-next-line no-unused-vars
    onEditorPreparing(e) {
      var that = this,
        rowIndex = e.row && e.row.rowIndex;
      if (e.dataField === "ProductCode") {
        e.editorOptions.onValueChanged = function(e) {
          that.dataSource[rowIndex].ProductCode = e.value;
        };
      }
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    defaultPriceChanged(e, cellInfo) {
      // const index = this.brokenGridValidations.findIndex(
      //   (x) =>
      //     x.Code === this.templateData.data.Code &&
      //     x.Batch === cellInfo.data.BatchNo
      // );
      // if (index > -1) {
      //   this.brokenGridValidations.splice(index, 1);
      // }

      if (this.dataSource.length > 0) {
        this.dataSource[cellInfo.rowIndex].DefaultPrice = e.value;
        this.updateReviewList(this.templateData.data);
      }
    },
    onInitNewRow(e) {
      e.data.DefaultPrice = this.templateData.data.DefaultPrice;
    },
    // eslint-disable-next-line no-unused-vars
    onRowRemoved(e) {},

    // eslint-disable-next-line no-unused-vars
    onContentReady(e) {
      // this.$logger.debug("content ready", e);

      if (addingNewBatchRow && this.templateData) {
        addingNewBatchRow = false;
        let grid = this.$refs["batch-child-grid-" + this.templateData.key]
          .instance;

        let recordCount = grid.getDataSource().items().length;
        // this.$logger.debug(recordCount);
        if (recordCount > 0) {
          let editElement = grid.getCellElement(recordCount - 1, 0);
          grid.focus(editElement);
          editElement.click();
        }
      }
    },

    onAddClickHandler() {
      let obj = Object.assign({}, baseLineBase);
      obj.DefaultPrice = this.templateData.data.DefaultPrice;

      this.dataSource.push(obj);
      if (this.$refs["batch-child-grid-" + this.templateData.key]) {
        let grid = this.$refs["batch-child-grid-" + this.templateData.key]
          .instance;

        grid.repaint();
      }
      addingNewBatchRow = true;
    },
    recalculateTotal() {
      this.$logger.debug(
        "recalculateTotal StockTransferProductBatches",
        this.templateData.data.CustomerSalesContractItemConsumptions
      );

      this.templateData.data.CustomerSalesContractItemConsumptions = this.dataSource;
    },
    async onProductLineContextMenuItemClick(e) {
      if (e.event) this.moreMenuCallBack(e.itemData, this.templateData.data);
    },
  },
  watch: {
    noOfRecords: {
      handler: function(value) {
        // add a record if the no of items in the datasource is 0
        if (this.allowEdit && value == 0) {
          this.onAddClickHandler();
        }
      },
    },
  },
};
</script>
<style>
/* @import "../dx-styles.scss"; */
</style>
